import React from 'react';
import KaraokeDetailsFormView from './KaraokeDetailsFormView';
import KaraokeModificationFormConfirmInProgressPopup from './KaraokeModificationFormConfirmWithFeeBeforeDistributionPopup';

type KaraokeDetailsFormPopupName = 'confirm';

export default function KaraokeDetailsForm({
  karaokeOrder,
  isWaitingForPayment,
  isWaitingForUpload,
  isRoyaltyOptionSelected,
  isDeliveryCompleted,
  isRegistrationInProgress,
  shouldModifyWithFee,
  modificationFeeAmount,
} : {
  karaokeOrder: {
    id: number,
    title: string,
    title_kana: string,
    artist_name: string,
    artist_name_kana: string,
    lyric_writer_name: string,
    composer_name: string,
    applicant_name: string,
    royalty_order: string,
    delivery_status: number,
    delivery_status_text: string,
    upload_hash: string,
    physical: number,
    already_entrusted: number,
    onvocal: number,
    duet: number,
  },
  isWaitingForPayment: boolean,
  isWaitingForUpload: boolean,
  isPaymentCompleted: boolean,
  isRoyaltyOptionSelected: boolean,
  isDeliveryCompleted: boolean,
  isRegistrationInProgress: boolean,
  shouldModifyWithFee: boolean,
  modificationFeeAmount: number,
}) {
  const [popup, setPopup] = React.useState<KaraokeDetailsFormPopupName|null>(null);

  return (
    <>
      <KaraokeDetailsFormView
        karaokeOrder={karaokeOrder}
        isRoyaltyOptionSelected={isRoyaltyOptionSelected}
        isWaitingForPayment={isWaitingForPayment}
        isWaitingForUpload={isWaitingForUpload}
        isDeliveryCompleted={isDeliveryCompleted}
        isRegistrationInProgress={isRegistrationInProgress}
        distributionStatusText={karaokeOrder.delivery_status_text}
        onResumePayment={() => {
          window.location.href = `/karaoke_orders/completed/${karaokeOrder.id}`;
        }}
        onResumeUpload={() => {
          window.location.href = `/karaoke_upload/form/${karaokeOrder.upload_hash}`;
        }}
        onRequestModification={() => {
          if (!isDeliveryCompleted && shouldModifyWithFee) {
            setPopup('confirm');
            return;
          }
          window.location.href = `/karaoke_modification/karaoke_modification/${karaokeOrder.id}`;
        }}
        onCancelDistribution={() => {
          window.location.href = `/karaoke_modification/karaoke_distribution_cancel/${karaokeOrder.id}`;
        }}
        onStartRegistration={() => {
          window.location.href = `/karaoke_modification/karaoke_registration_start/${karaokeOrder.id}`;
        }}
        onCancelRegistration={() => {
          window.location.href = `/karaoke_modification/karaoke_registration_cancel/${karaokeOrder.id}`;
        }}
      />
      {popup === 'confirm' && (
        <KaraokeModificationFormConfirmInProgressPopup
          onClose={() => {
            setPopup(null);
          }}
          onBack={() => {
            window.location.href = '/';
          }}
          onNext={() => {
            window.location.href = `/karaoke_modification/karaoke_modification/${karaokeOrder.id}`;
          }}
          modificationFeeAmount={modificationFeeAmount}
        />
      )}
    </>
  );
}
